import * as React from 'react';

import { NavStyles } from './NavigationStyles';
import { NavPanelDisplayMode } from './NavPanel';

export interface NavSectionSeparatorProps {
  readonly navPanelDisplayMode: NavPanelDisplayMode;
}

export class NavSectionSeparator extends React.Component<NavSectionSeparatorProps, {}> {
  public constructor(props: NavSectionSeparatorProps) {
    super(props);
  }

  public render(): JSX.Element {
    const className = this.props.navPanelDisplayMode === 'icon' ? NavStyles.SeparatorCollapsed : NavStyles.SeparatorExpanded;
    return (
      <div className={className} />
    );
  }
}
